const creators = [
	{
		path: '/academy/creators/list',
		name: 'academy-creators-list',
		component: () => import('@/views/academy/creators/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGA,courses',
		},
	},
	{
		path: '/academy/creators/detail/:id',
		name: 'academy-creators-detail',
		component: () => import('@/views/academy/creators/detail.vue'),
		meta: {
			layout: 'content',
			module: 'MGA,courses',
		},
	},
	{
		path: '/academy/creator-applications/list',
		name: 'academy-creator-applications-list',
		component: () => import('@/views/academy/creator-applications/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGA,courses',
		},
	},
	{
		path: '/academy/creator-applications/detail/:id',
		name: 'academy-creator-applications-detail',
		component: () => import('@/views/academy/creator-applications/detail.vue'),
		meta: {
			layout: 'content',
			module: 'MGA,courses',
		},
	},
	{
		path: '/academy/bookings/list',
		name: 'academy-bookings-list',
		component: () => import('@/views/academy/bookings/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGA,courses',
		},
	},
]

export default creators
